<template>
  <div class="checkbox-group"
       :class="{ 'header-only': headerOnly }">
    <div class="form__input form__input--checkbox form__input--checkbox--bold"
         v-if="actualHeaderWord">
      <input :id="labelId"
             type="checkbox"
             v-model="labelChecked">
      <label :for="labelId"
             v-word="actualHeaderWord" />
    </div>

    <div v-if="!this.headerOnly"
         class="form__input form__input--checkbox form__input--checkbox--group">
      <div v-for="(labelWordingId, value) in valDef"
           :key="value">
        <input v-model="statuses[value]"
               :id="id + value"
               type="checkbox">
        <label :for="wordingsEditable ? '' : (id + value)"
               v-word="labelWordingId" />
      </div>
    </div>
  </div>
</template>

<script>
import wordDirective from '../directives/word';
import formElement from '../mixins/form-element';

export default {
  mixins: [formElement],
  props: [
    'data',
    'valDef',
    'wordings',
    'wordingsEditable',
    'wordingsMeta',
    'headerWord',
  ],
  directives: {
    word: wordDirective,
  },
  data() {
    return {
      id: '' + this.data.valName + '__' + Math.random(),
      labelId: '' + this.data.valName + '-label__' + Math.random(),
      statuses: {},
      labelChangedAutomatically: true,
      actualHeaderWord: '',
      headerOnly: false,
    };
  },
  computed: {
    labelChecked: {
      get() {
        for (let valName of Object.keys(this.statuses)) {
          if (this.statuses[valName]) {
            return true;
          }
        }
        return false;
      },
      set(newVal) {
        for (let valName of Object.keys(this.statuses)) {
          this.statuses[valName] = !!newVal;
        }
      },
    },
  },
  watch: {
    statuses: {
      handler() {
        const newVal = [];
        for (const [valName, val] of Object.entries(this.statuses)) {
          if (val) {
            newVal.push(valName);
          }
        }
        this.$emit('change', newVal, this.data.valName);
      },
      deep: true,
    },
    data: {
      handler() {
        this.populate();
      },
      deep: true,
    },
  },
  created() {
    this.populate();
  },
  methods: {
    populate() {
      let defaultVal;
      const defaultVals = Array.isArray(this.data.val) ? this.data.val : [];

      for (let valName of Object.keys(this.valDef)) {
        defaultVal = defaultVals.includes(valName);
        this.$set(this.statuses, valName, defaultVal);
      }

      this.actualHeaderWord = this.headerWord;

      if (Object.keys(this.valDef).length === 1 && !this.actualHeaderWord) {
        this.actualHeaderWord = this.valDef[Object.keys(this.valDef)[0]];
        this.headerOnly = true;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/InputCheckboxGroup.vue